import request from '@/utils/request'
//新闻动态
export const getEnterpriseList = (data) => request.post('/official/news/enterprise',data)
//新闻详情
export const getEnterpriseInfo = (id) => request.get(`/official/news/enterprise/${id}`)
//服务案例
export const getServiceCaseList = () => request.get(`/official/news/serviceCase`)
//详情-推荐列表
export const getNewsRecommendList = (id) => request.get(`/official/news/enterprise/recommend?id=${id}`)

